import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
const bonos = ['Kit Primera Consulta Premium', 'Banco de WhatsApps Profesionales', 'Pack de Tareas para Casa', 'Pack de Derivaciones e Interconsultas', 'Planificador de Sesión en 10 Minutos', 'Sistema Anti-Improvisación Clínica'];
export function Bonuses() {
  return <section className="py-8 bg-transparent" data-id="element-16">
      <div className="container mx-auto px-6 max-w-5xl" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-orange-500/10 border border-orange-500/30 text-orange-300 text-xs font-bold tracking-wider uppercase mb-6" data-id="element-19">
            <Sparkles className="w-3.5 h-3.5" data-id="element-20" />
            Bonos exclusivos
          </motion.div>

          <h2 className="text-3xl md:text-5xl font-black mb-4 flex items-center justify-center gap-3 flex-wrap leading-tight" data-id="element-21">
            <Gift className="w-9 h-9 md:w-10 md:h-10 text-orange-500" data-id="element-22" />
            <span data-id="element-23">+6 Bonos</span>
            <span className="text-gradient" data-id="element-24">GRATIS</span>
            <span data-id="element-25">al instante</span>
          </h2>

          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto mb-8" data-id="element-26">
            Recursos extra para que arranques con todo — sin costo adicional.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-3 px-5 py-3 rounded-2xl bg-black/60 border-2 border-orange-500/40 shadow-[0_0_25px_rgba(255,107,26,0.25)]" data-id="element-27">
            <span className="text-sm md:text-base text-gray-400" data-id="element-28">
              Valor real{' '}
              <span className="line-through decoration-orange-500/70 decoration-2" data-id="element-29">
                $149.000
              </span>
            </span>
            <span className="px-3 py-1 rounded-lg bg-gradient-primary text-white text-sm md:text-base font-extrabold tracking-wide shadow-lg" data-id="element-30">
              HOY GRATIS
            </span>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-31">
          {bonos.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#0a0a0a] p-6 rounded-2xl relative overflow-hidden border border-orange-500/40 hover:border-orange-500/70 transition-colors" data-id="element-32">
              <div className="absolute top-0 right-0 bg-orange-500/15 text-orange-400 text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-33">
                INCLUIDO
              </div>
              <div className="text-4xl font-black text-white/5 mb-4" data-id="element-34">
                0{i + 1}
              </div>
              <h3 className="text-lg font-bold text-white relative z-10" data-id="element-35">
                {bono}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}